module.exports = __webpack_public_path__ + "img/icon-team-3.5a83684f.svg";